<template>
  <div class="book-link">
    <ui-hr>{{ $t("linkToInviteCollaborators") }}</ui-hr>
    <ui-accordion size="sm">
      <ui-accordion-item
        :active="showEdit"
        :title="link"
        :open-on-click-title="false"
      >
        <p slot="close" class="title">
          <span v-if="isAuthor" @click="editLink"
            ><ui-icon name="icon-edit-square"></ui-icon>{{ $t("edit") }}</span
          >
          <span class="muted" v-if="isAuthor">|</span>
          <span
            v-clipboard:copy="link"
            v-clipboard:success="onCopy"
            :title="$t('copyLink')"
            class="pointer"
            ><ui-icon name="icon-file-copy"></ui-icon>{{ $t("copy") }}</span
          >
        </p>
        <ui-v ref="link-form" :rules="linkRules">
          <ui-input
            name="link"
            v-model="book.code"
            :max-length="20"
            :placeholder="$t('typeNewCodeHere')"
          >
            <span slot="prefix">{{ host }}</span>
          </ui-input>
        </ui-v>
        <ui-button-group>
          <ui-button
            @click="saveLink"
            v-if="showEdit"
            size="sm"
            type="border"
            >{{ $t("saveLink") }}</ui-button
          >
          <ui-button @click="cancel" v-if="showEdit" size="sm" type="border">{{
            $t("cancel")
          }}</ui-button>
        </ui-button-group>
      </ui-accordion-item>
    </ui-accordion>
    <!--  <p>
      <span v-if="isAuthor && !showEdit" @click="editLink" class="pointer"><ui-icon name="icon-edit-square"></ui-icon></span><span v-if="showEdit">{{$t('oldLinkVanished')}}</span>
      <span class="muted" v-if="isAuthor && !showEdit">|</span>
      <span  v-if="!showEdit" v-clipboard:copy="link" v-clipboard:success="onCopy" :title="$t('copyLink')" class="pointer"><ui-icon name="icon-file-copy"></ui-icon>{{$t('copy')}}</span>
    </p>
    <p v-if="!showEdit">
      <span class="color">{{link}}</span>
    </p>
 -->
  </div>
</template>
<script>
import api from "../../api/index";
import config from "../../config.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showEdit: false,
      linkRules: {
        link: [
          {
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("code")
          },
          {
            type: "minLength",
            length: 4,
            trigger: "submit",
            message: this.$t("code") + this.$t("tooShort", { len: 4 })
          },
          {
            type: "maxLength",
            length: 20,
            trigger: "submit",
            message: this.$t("code") + this.$t("tooLong", { len: 20 })
          },
          {
            type: /^[A-Za-z0-9_.]+$/,
            trigger: "submit",
            message: this.$t("code") + this.$t("notAllowSpecialCharacters")
          }
        ]
      }
    };
  },
  props: ["book"],
  computed: {
    ...mapGetters(["authInfo"]),
    isAuthor() {
      return this.authInfo && this.authInfo.id === this.book.userInfo.id;
    },
    host() {
      return `${config[process.env.NODE_ENV].fullHost}/@${
        this.book.userInfo.username
      }/`;
    },
    link() {
      return `${this.host}${this.book.code}`;
    }
  },
  methods: {
    cancel() {
      this.showEdit = false;
    },
    saveLink() {
      this.$refs["link-form"].validate().then(() => {
        this.code = this.book.code;
        this.updateCode();
      });
    },
    editLink() {
      this.showEdit = true;
      this.$nextTick(() => {
        this.$refs["editInput"].focus();
        this.$refs["editInput"].select();
      });
    },
    onCopy() {
      this.$UiToast({
        message: this.$t("linkCopied")
      });
    },
    updateCode() {
      api
        .updateBookCode({
          code: this.book.code,
          aid: this.book.id
        })
        .then(res => {
          // todo: binding a from path in vue-router
          // this is a temporary solution
          history.pushState(
            null,
            null,
            `${config[process.env.NODE_ENV].fullHost}/index`
          );

          if (res.data.ok) {
            this.showEdit = false;
            this.$router.push(
              `/@${this.book.userInfo.username}/${this.book.code}`
            );
          }
          if (res.data.err) {
            this.$refs["link-form"].parseError({
              name: "link",
              message: this.$t("code") + this.$t("alreadyBeenTaken")
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  white-space: nowrap;
  padding-left: 20px;
  margin: 0;
}

.ui-hr {
  margin-top: 2rem;
}
</style>
